import React from "react";
// import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
    columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
// import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
// import { setDateFilter } from "src/redux/slices/PaymentSlice";

import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
// import { CSVLink } from "react-csv";
import ATMExportButton from "src/components/UI/atoms/ATMExportButton/ATMExportButton";
import moment from "moment";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import PaymentFilterDialogWrapper from "./FilterDialog/PaymentFilterDialogWrapper";

type Props = {
    columns: columnTypes[];
    getPaymentExcel: any
    isloadingExcel: boolean
    rows: any[];
    // excelData: any[];
    paginationProps: {
        isTableLoading: boolean;
        totalItems: number;
        page: number;
        rowsPerPage: number;
        searchValue: string;
        setPage: (newPage: number) => void;
        setRowsPerPage: (newLimit: number) => void;
        setSearchValue: (newValue: string) => void;
    };
};

const PaymentListing = ({
    columns,
    rows,
    // excelData,
    getPaymentExcel,
    isloadingExcel,
    paginationProps: {
        isTableLoading,
        totalItems,
        page,
        rowsPerPage,
        searchValue,
        setPage,
        setRowsPerPage,
        setSearchValue,
    },
}: Props) => {
    const { dateFilter } = useSelector((state: RootState) => state.payment);
    const [paymentExcel, setPaymentExcel] = React.useState([])
    const [openFilterDialog, setOpenFilterDialog] = React.useState<boolean>(false);

    const excelPayemntData = paymentExcel?.map((ele: any) => {
        const { __v, _id, paymentModeId, updatedAt, orderId, franchiseId, paymentMode, createdById, createdAt, franchise, ...rest } = ele;
        return { createdAt: formatedDateTimeIntoIst(createdAt, "DD MMM yyyy"), ...rest };
    });
    // const dispatch = useDispatch();
    //   const flatData = rows?.reduce((result, entry) => {
    //     entry.paymentMode.forEach((paymentMode: any) => {
    //       const flatEntry = {
    //         ...entry,
    //         paymentModeName: paymentMode.paymentModeName,
    //         amount: paymentMode.amount,
    //       };
    //       delete flatEntry.paymentMode;
    //       result.push(flatEntry);
    //     });
    //     return result;
    //   }, []);

    return (
        <SideNavLayout>
            <div className="flex flex-col h-full p-4">
                {/* Page Header */}
                <div className="p-4">
                    <ATMPageHeader
                    moduleName="PAYMENTS"
                        pageTitle="Payments"
                        searchValue={searchValue}
                        isFilter
                        onFilterClick={() => setOpenFilterDialog(true)}
                        onSearchChange={setSearchValue}
                        hideAddButton
                    />
                </div>

                <div className="flex justify-between items-center mx-3 my-1  mb-4" >
                    <div>
                        {/* <div className="flex justify-end items-center ">
                            <div className="flex gap-2  items-center">
                                <div className="min-w-[200px] max-w-[200px]">
                                    <ATMDatePicker
                                        name=""
                                        value={dateFilter.start_date}
                                        onChange={(value) => {
                                            dispatch(
                                                setDateFilter({ ...dateFilter, start_date: value })
                                            );
                                        }}
                                        label="Start Date"
                                    />
                                </div>

                                <div className="min-w-[200px] max-w-[200px]">
                                    <ATMDatePicker
                                        name=""
                                        value={dateFilter.end_date}
                                        onChange={(value) => {
                                            dispatch(
                                                setDateFilter({ ...dateFilter, end_date: value })
                                            );
                                        }}
                                        label="End Date"
                                        minDate={
                                            dateFilter.start_date
                                                ? new Date(dateFilter.start_date)
                                                : undefined
                                        }
                                    />
                                </div>
                                {dateFilter?.start_date || dateFilter?.end_date ? (
                                    <div>
                                        <button
                                            type="button"
                                            className={`rounded bg-primary-main text-white py-2 px-2 mt-4`}
                                            onClick={() => {
                                                dispatch(
                                                    setDateFilter({ start_date: null, end_date: null })
                                                );
                                            }}
                                        >
                                            Clear Date Filter
                                        </button>
                                    </div>
                                ) : null}
                            </div>
                        </div> */}
                    </div>
                    <ATMExportButton
                        headers={[
                            { label: "Date-Time", key: "createdAt" },
                            { label: "Franchise name", key: "franchiseName" },
                            { label: "Mobile Number", key: "mobile" },
                            { label: "Actual Amount", key: "actualAmount" },
                            { label: "Adjust Against Mobile", key: "adjustAgainstMobile" },
                            { label: "Due Amount", key: "dueAmount" },


                        ]}
                        // ref={'exportRef'}
                        fileName='payment-excel.csv'
                        onClick={(done) => {
                            getPaymentExcel({
                                limit: rowsPerPage,
                                searchValue: searchValue,
                                params: ["mobile"],
                                page: page,
                                filterBy: [],
                                dateFilter: {
                                    startDate: dateFilter.start_date
                                        ? moment(dateFilter?.start_date).format("YYYY-MM-DD")
                                        : "",
                                    endDate: dateFilter.end_date
                                        ? moment(dateFilter?.end_date).format("YYYY-MM-DD")
                                        : dateFilter.start_date ? moment().format("YYYY-MM-DD") : ''
                                },
                                orderBy: "createdAt",
                                orderByValue: -1,
                                isPaginationRequired: false,
                            }).then((res: any) => {
                                if (res.data?.status) {
                                    setPaymentExcel(res?.data?.data);
                                    setTimeout(() => {

                                        done()
                                    }, 1000)
                                }
                            })

                        }}
                        btnName="Export"
                        loadingText="Exporting..."
                        data={excelPayemntData}
                        isLoading={isloadingExcel}
                    />
                </div>
                {/* Table */}
                <div className="flex-1 overflow-auto flex flex-col">
                    <ATMTable
                        columns={columns}
                        rows={rows}
                        rowExtraClasses={() => "min-h-[40px]"}
                        isLoading={isTableLoading}
                    />
                </div>

                <div className="p-4 py-2">
                    <ATMPagination
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={setPage}
                        onRowsPerPageChange={setRowsPerPage}
                        rowCount={totalItems}
                        rows={rows}
                    />
                </div>
                {openFilterDialog ? <PaymentFilterDialogWrapper onClose={() => { setOpenFilterDialog(false) }} /> : null}
            </div>
        </SideNavLayout>
    );
};

export default PaymentListing;
